import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { FooterData, SupportInfos } from "@hermes/api-model-shell";
import { Settings } from "@hermes/core-app-core";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils-generic-constants";

/**
 * Service to fetch footer data
 */
@Injectable()
export class FooterService {
    private http = inject(HttpClient);
    private settings = inject(Settings);

    /**
     * Fetch footer items from Drupal
     */
    public fetchFooterData(): Observable<FooterData> {
        const context = new HttpContext().set(SKIP_404_INTERCEPTOR, true);

        return this.http.get<FooterData>(
            `${this.settings.apiUrl}/footer-items`,
            {
                context,
            },
        );
    }

    /**
     * Fetch support infos from Drupal
     */
    public fetchSupportInfosData(): Observable<SupportInfos> {
        const context = new HttpContext().set(SKIP_404_INTERCEPTOR, true);

        return this.http.get<SupportInfos>(
            `${this.settings.apiUrl}/support-infos`,
            {
                context,
            },
        );
    }
}
